var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import InputComponent from "../InputComponent";
import { useSelector } from "react-redux";
import actions from "@redux/feature/Markets/NCD/actions/TransactionJourneyActions";
import AccordionComponent from "../AccordionComponent";
import FileUploadComponent from "../FileUploadComponent";
import TransactionJourneyBankSelector from "../TransactionJourneyBankSelector";
var StockBuyRecords = function () {
    var cActions = new actions();
    var _a = useSelector(function (state) { return state.markets.Otc.transactionJourneyReducer; }), bankDetails = _a.bankDetails, paymentMode = _a.paymentMode;
    var handleOnChangeInputs = function (value) {
        var updatedPayment = __assign(__assign({}, paymentMode), { chequeNo: value });
        cActions.updatePaymentModeValues(updatedPayment);
        cActions.updateValidSetUpFess(false);
    };
    return (React.createElement("div", { className: "d-flex flex-column gap-24 position-relative" },
        React.createElement(InputComponent, { label: "Stock Transfer No", placeholder: "Enter Stock Transfer No", helperText: "", name: "stock", required: true, maxLength: 30, alphanum: true, onChangeEvent: function (event) {
                handleOnChangeInputs(event.target.value);
            }, value: paymentMode.chequeNo }),
        React.createElement("div", { className: "d-flex align-items-start gap-2 new-mandate-section" },
            React.createElement("div", { className: "w-100 dropdown-container" },
                React.createElement(TransactionJourneyBankSelector, { data: bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.data }))),
        React.createElement("div", { className: "bank-upload stock-buy-records" },
            React.createElement(AccordionComponent, { isDefalutKey: "0", items: [
                    {
                        header: "Upload DIS Scan/Demat Debit Statement",
                        body: React.createElement(FileUploadComponent, { fileSize: 5 }),
                        optional: false,
                        leftIcon: null,
                        info: false,
                    },
                ] }))));
};
export default StockBuyRecords;
